//src/api/learner/learnerApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const initiateAssessments = async (fullName, email, projectId, projectCode) => {
  return await axios.post(`${API_URL}/learner/initiate`, { fullName, email, projectId, projectCode });
};

export const saveLearnerResponse = async (learnerResponseId, questionResponse) => {
  return await axios.post(`${API_URL}/learner/save-response`, { learnerResponseId, questionResponse });
};

export const scoreLearnerResponse = async (learnerResponseId, questionDetails) => {
  return await axios.post(`${API_URL}/learner/score-response`, { learnerResponseId, ...questionDetails });
};

export const getNextConversationalQuestion = async (learnerResponseId) => {
  return await axios.post(`${API_URL}/learner/next-question`, { learnerResponseId });
};

export const checkEligibility = async (projectId, email, projectCode) => {
    // console.log('projectId', projectId,email);
    return await axios.post(`${API_URL}/learner/check-eligibility`, { projectId, email, projectCode });
};

export const getAssessmentResults = async (projectId, page = 1, limit = 15, testType) => {
  return await axios.get(`${API_URL}/learner/assessment-results/${projectId}`, {
    params: { page, limit, test_type: testType },
  });
};

export const getLearnerLeaderboard = async (projectId, learnerEmail, testType) => {
  return await axios.get(`${API_URL}/learner/leaderboard`, {
    params: { projectId, learnerEmail, test_type: testType },
  });
};

export const checkPreAssessmentExistence = async (projectId) => {
  return await axios.get(`${API_URL}/learner/check-pre-existence`, {
    params: { projectId },
  });
};

export const getLearnerPastAssestment = async(userEmail)=>{
  return await axios.get(`${API_URL}/learner/past-assessments`,{
    params:{userEmail},
  });
};

export const getComparisonResults = async (projectId, page = 1, limit = 15) => {
  return await axios.get(`${API_URL}/learner/compare-results`, {
    params: { projectId, page, limit },
  });
};

export const updateLearnerEmail = async (learnerResponseId, email, projectId, projectCode) => {
  return await axios.post(`${API_URL}/learner/update-email`, { learnerResponseId, email, projectId, projectCode });
};

export const deleteGeneratedEmailData = async (learnerResponseId) => {
  return await axios.delete(`${API_URL}/learner/delete-generated-email-data`, {
    params: { learnerResponseId }, // Pass as query parameter
  });
};

export const downloadLearnerAssessmentPDF = async (assessmentId) => {
  try {
    assessmentId = assessmentId.trim(); 
    const response = await axios.get(`${API_URL}/learner/download-pdf/${assessmentId}`, {
      responseType: "blob", // Important for handling file downloads
    });

    // Create a Blob URL for the PDF file
    const file = new Blob([response.data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);

    // Create a download link and trigger it
    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Assessment_${assessmentId}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};
export const finishAssessment = async(learnerResponseId) => {
  return await axios.post(`${API_URL}/learner/finish`, { learnerResponseId });
};